window.jQuery = $;
window.$ = $;
